module.exports = __webpack_public_path__ + "static/media/Icn-ttf.0d7b746f.svg";